import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "../ga";

export default function usePageViewTracking() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
}
